// extracted by mini-css-extract-plugin
module.exports = {"icon":"index__icon___3a4EQ"};